import {
  createStyles,
  Grid,
  makeStyles,
  Paper,
  TextField,
  Theme,
} from "@material-ui/core";
import {
  GET_BLOCK_WITH_MARKERS_BY_ID,
  GetBlockWithMarkersQueryResult,
} from "Graphql/BlockQueries";
import MaterialTable from "material-table";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FC } from "react";
import { useQuery } from "@apollo/react-hooks";
import { useParams } from "react-router-dom";
import { RouteParams } from "Models/RouteParams";
// import { useTranslation } from "react-i18next";
import { useAuth } from "auth";
import { TableIcons } from "Views/Components/Icons/TableIcons";
import { CPOMonthDataDate } from "Models/CPOMonthDataDate";
import { Location } from "history";
import { CPODeferralData } from "Models/CPODeferralData";
import { CPODeferralSystems } from "Models/CPODeferralSystems";
import { CPODeferralAssets } from "Models/CPODeferralAssets";
import moment from "moment";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { Roles } from "Enums/Roles";
import Select, { MultiValue } from "react-select";
import { OptionType } from "Models/OptionType";
import { CheckboxOption } from "Logic/SubSystemOptions/CheckboxOption";
import { CustomStylesSubSystemOptions } from "Logic/SubSystemOptions/CustomStylesSubSystemOptions";
import { KeycloakProfile } from "auth";
import { CPOEditReasons } from "Models/CPOEditReasons";
import { useTranslation } from "react-i18next";

interface DeferralPageState {
  rowData: CPOMonthDataDate;
}

interface CPODeferralTableProps {
  location: Location<DeferralPageState>;
  initialMonth?: MaterialUiPickersDate;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      display: "flex",
      alignItems: "stretch",
    },
    dropdown: {
      margin: theme.spacing(2),
      minWidth: 100,
    },

    monthPicker: {
      padding: theme.spacing(1),
    },
    monthPickerGrid: {
      paddingBottom: theme.spacing(1),
      flexWrap: "nowrap",
    },
  }),
);

export const CPODeferralTable: FC<CPODeferralTableProps> = ({
  location,
  initialMonth,
}) => {
  const classes = useStyles();
  const { t } = useTranslation("cpo");
  const { blockId } = useParams<RouteParams>();
  const { auth } = useAuth();

  const [userProfile, setUserProfile] = useState<KeycloakProfile | undefined>(
    undefined,
  );
  const [cpoMonthDeferralData, setCpoMonthDeferralData] = useState<
    CPODeferralData[] | undefined
  >(undefined);
  const [cpoDeferralSystems, setCpoDeferralSystems] = useState<
    CPODeferralSystems[] | undefined
  >(undefined);

  const [cpoDeferralAssets, setCpoDeferralAssets] = useState<
    CPODeferralAssets[] | undefined
  >(undefined);

  const [datePickerChangedBool, setDatePickerChangedBool] = useState(false);

  const [selectedAssets, setSelectedAssets] = useState<MultiValue<OptionType>>(
    [],
  );

  const [selectedSystems, setSelectedSystems] = useState<
    MultiValue<OptionType>
  >([]);
  const [selectedPlannedUnplanned, setSelectedPlannedUnplanned] = useState<
    MultiValue<OptionType>
  >([]);

  const [cpoEditReasons, setCpoEditReasons] = useState<
    CPOEditReasons[] | undefined
  >(undefined);

  const plannedUnplannedLookup = useMemo(
    () => ({
      planned: t("planned"),
      unplanned: t("unplanned"),
    }),
    [t],
  );
  const loadUserProfile = useCallback(async () => {
    try {
      const response = await auth?.loadUserProfile();
      setUserProfile(response);
    } catch (error) {
      auth?.logout();
    }
  }, [auth]);

  useEffect(() => {
    loadUserProfile();
  }, [loadUserProfile]);

  let cpoFileSubmissionRowData: CPOMonthDataDate | undefined = undefined;
  let defaultFilterDate: Date | undefined = undefined;

  if (location.state) {
    const { rowData } = location.state;
    cpoFileSubmissionRowData = rowData;
    if (cpoFileSubmissionRowData) {
      if (Array.isArray(cpoFileSubmissionRowData)) {
        if (
          cpoFileSubmissionRowData.length > 0 &&
          cpoFileSubmissionRowData[0]?.date
        ) {
          defaultFilterDate = new Date(cpoFileSubmissionRowData[0].date);
        }
      } else {
        if (cpoFileSubmissionRowData.date) {
          defaultFilterDate = new Date(cpoFileSubmissionRowData.date);
        }
      }
    }
  }

  const [selectedMonth, setSelectedMonth] = useState<string>(
    defaultFilterDate
      ? moment(defaultFilterDate).format("MMMM")
      : moment().format("MMMM"),
  );
  const [selectedYear, setSelectedYear] = useState<string>(
    defaultFilterDate
      ? moment(defaultFilterDate).format("YYYY")
      : moment().format("YYYY"),
  );

  const { data: blockData } = useQuery<GetBlockWithMarkersQueryResult>(
    GET_BLOCK_WITH_MARKERS_BY_ID,
    { variables: { id: blockId } },
  );

  const fetchCpoDeferralData = useCallback(
    async (
      month: number,
      year: number,
      blockData: GetBlockWithMarkersQueryResult,
    ) => {
      const blockQueryText = blockData?.block.name
        .replace(" ", "_")
        .toLowerCase();
      const url =
        process.env.REACT_APP_CPO_API_URL +
        // `http://localhost:8000` +
        `/api/deferrals?month=${month}&year=${year}&block=${blockQueryText}`;
      try {
        const token = await auth?.getToken();
        const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                    }
                  });
        if (!response.ok) {
          console.error(`HTTP error! status: ${response.status}`);
          return;
        }
        const rawText = await response.text();

        const validJsonText = rawText.replace(/: NaN/g, ": 1");

        const responseJsonParsed = JSON.parse(validJsonText);
        const rawData = JSON.parse(responseJsonParsed);

        console.log(rawData);

        setCpoMonthDeferralData(rawData.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    // eslint-disable-next-line
    [],
  );

  useEffect(() => {
    if (selectedMonth && selectedYear && blockData) {
      const monthNumber = moment().month(selectedMonth).month() + 1;
      fetchCpoDeferralData(monthNumber, parseInt(selectedYear, 10), blockData);
    }
  }, [selectedMonth, selectedYear, fetchCpoDeferralData, blockData]);

  const monthOptions = useMemo(() => {
    return moment.months().map((month) => ({
      value: month,
      label: month,
    }));
  }, []);

  const yearOptions = useMemo(() => {
    const currentYear = moment().year();
    const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);
    return years.map((year) => ({
      value: year.toString(),
      label: year.toString(),
    }));
  }, []);

  useEffect(() => {
    async function fetchCpoSystems() {
      if (blockData) {
        const url = process.env.REACT_APP_CPO_API_URL + `/api/systems`;
        try {
          const token = await auth?.getToken();
          const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                    }
                  });
          if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`);
            return;
          }

          const rawJsonString = await response.json();
          const responseData = JSON.parse(rawJsonString);

          if (
            responseData &&
            typeof responseData === "object" &&
            responseData !== null &&
            Array.isArray(responseData.cpoSystems)
          ) {
            setCpoDeferralSystems(responseData.cpoSystems);
          } else {
            console.warn(
              "WARNING: API response did not contain an array 'cpoSystems' as expected.",
              responseData,
            );
          }
        } catch (error) {
          console.error("Error fetching systems:", error);
        }
      } else {
        console.error("fetchCpoSystems skipped because blockData is falsy.");
      }
    }
    fetchCpoSystems();
    // eslint-disable-next-line
  }, [blockData]);

  useEffect(() => {
    async function fetchCpoEditReasons() {
      if (blockData) {
        const url = process.env.REACT_APP_CPO_API_URL + `/api/edit/reason`;
        try {
          const token = await auth?.getToken();
          const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                    }
                  });
          if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`);
            return;
          }

          const rawJsonString = await response.json();
          const responseData = JSON.parse(rawJsonString);

          if (
            responseData &&
            typeof responseData === "object" &&
            responseData !== null &&
            Array.isArray(responseData.editReasons)
          ) {
            const category = "reasonCategory";
            const categoryValue = ["deferrals", "general"];

            const filteredEditReasons = responseData.editReasons.filter(
              (reason) => categoryValue.includes(reason[category]),
            );
            setCpoEditReasons(filteredEditReasons);
          } else {
            console.warn(
              "WARNING: API response did not contain an array 'edit reasons' as expected.",
              responseData,
            );
          }
        } catch (error) {
          console.error("Error fetching edit reasons:", error);
        }
      } else {
        console.error(
          "fetchCpoEditReasons skipped because blockData is falsy.",
        );
      }
    }
    fetchCpoEditReasons();
    // eslint-disable-next-line
  }, [blockData]);

  useEffect(() => {
    async function fetchCpoAssets() {
      if (blockData) {
        const blockQueryText = blockData?.block.name
          .replace(" ", "_")
          .toLowerCase();
        const url =
          process.env.REACT_APP_CPO_API_URL +
          //`http://localhost:8000`+
          `/api/assets?block=${blockQueryText}`;
        try {
          const token = await auth?.getToken();
          const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                    }
                  });
          if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`);
            return;
          }

          const rawJsonString = await response.json();
          const responseData = JSON.parse(rawJsonString);

          console.log(responseData);

          if (
            responseData &&
            typeof responseData === "object" &&
            responseData !== null &&
            Array.isArray(responseData.cpoAssets)
          ) {
            setCpoDeferralAssets(responseData.cpoAssets);
          } else {
            console.warn(
              "WARNING: API response did not contain an array 'cpoAssets' as expected.",
              responseData.cpoAssets,
            );
          }
        } catch (error) {
          console.error("Error fetching assets:", error);
        }
      } else {
        console.error("fetchCpoAssets skipped because blockData is falsy.");
      }
    }
    fetchCpoAssets();
    // eslint-disable-next-line
  }, [blockData]);

  const assetNameLookup = useMemo(() => {
    if (!cpoDeferralAssets || !Array.isArray(cpoDeferralAssets)) {
      return [];
    }
    const options: OptionType[] = cpoDeferralAssets.map((asset) => {
      return {
        value: asset.assetName,
        label: asset.assetName,
      };
    });
    return options;
  }, [cpoDeferralAssets]);

  const handleAssetChange = (option: MultiValue<OptionType>) => {
    setSelectedAssets(option);
  };

  const systemNameLookup = useMemo(() => {
    if (!cpoDeferralSystems || !Array.isArray(cpoDeferralSystems)) {
      return [];
    }
    const options: OptionType[] = cpoDeferralSystems.map((system) => {
      return {
        value: system.systemNumber.toString(),
        label: system.systemName,
      };
    });
    return options;
  }, [cpoDeferralSystems]);

  const handleSystemChange = (option: MultiValue<OptionType>) => {
    setSelectedSystems(option);
  };

  const plannedUnplannedOptions = useMemo(() => {
    return Object.keys(plannedUnplannedLookup).map((key) => ({
      value: key,
      label: plannedUnplannedLookup[key],
    }));
  }, [plannedUnplannedLookup]);

  const handlePlannedUnplannedChange = (option: MultiValue<OptionType>) => {
    setSelectedPlannedUnplanned(option);
  };

  const Option = CheckboxOption;

  const filteredTableData = useMemo(() => {
    const dataToFilter = cpoMonthDeferralData || [];

    const selectedAssetNames = selectedAssets.map((asset) => asset.value);
    const selectedSystemNumbers = selectedSystems.map((system) =>
      parseInt(system.value, 10),
    );
    const selectedPUOptions = selectedPlannedUnplanned.map(
      (option) => option.value,
    );

    return dataToFilter.filter((row) => {
      const passesAssetFilter =
        selectedAssetNames.length === 0 ||
        selectedAssetNames.includes(row.asset);

      const passesSystemFilter =
        selectedSystemNumbers.length === 0 ||
        selectedSystemNumbers.includes(row.system);

      const passesPUFilter =
        selectedPUOptions.length === 0 ||
        selectedPUOptions.includes(row.scheduled);

      return passesAssetFilter && passesSystemFilter && passesPUFilter;
    });
  }, [
    cpoMonthDeferralData,
    selectedAssets,
    selectedSystems,
    selectedPlannedUnplanned,
  ]);

  if (
    !auth?.hasRealmRole(Roles.cpoDeferralEditor) &&
    !auth?.hasRealmRole(Roles.administrator)
  ) {
    return null;
  }

  return (
    <>
      <Grid container className={classes.monthPickerGrid}>
          <Grid item xs={2} className={classes.dropdown}>
            <Select
              onChange={(option) => {
                setDatePickerChangedBool(true);
                setSelectedMonth((option as OptionType).value);
              }}
              options={monthOptions}
              value={monthOptions.find(
                (option) => option.value === selectedMonth,
              )}
              isMulti={false}
              styles={CustomStylesSubSystemOptions}
              placeholder={t("selectMonth")}
            />
          </Grid>
          <Grid item xs={2} className={classes.dropdown}>
            <Select
              onChange={(option) => {
                setDatePickerChangedBool(true);
                setSelectedYear((option as OptionType).value);
              }}
              options={yearOptions}
              value={yearOptions.find(
                (option) => option.value === selectedYear,
              )}
              isMulti={false}
              styles={CustomStylesSubSystemOptions}
              placeholder={t("selectYear")}
            />
          </Grid>

          <Grid item xs={2} className={classes.dropdown}>
            <Select
              onChange={(option) => handleAssetChange(option)}
              options={assetNameLookup}
              isMulti
              autoFocus
              isSearchable
              isClearable
              styles={CustomStylesSubSystemOptions}
              placeholder={t("filterAssets")}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{
                Option,
              }}
            />
          </Grid>
          <Grid item xs={2} className={classes.dropdown}>
            <Select
              onChange={handlePlannedUnplannedChange}
              options={plannedUnplannedOptions}
              isMulti
              isSearchable
              isClearable
              styles={CustomStylesSubSystemOptions}
              placeholder={t("filterPlannedUnplanned")}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option }}
            />
          </Grid>
          <Grid item xs={2} className={classes.dropdown}>
            <Select
              onChange={handleSystemChange}
              options={systemNameLookup}
              isMulti
              isSearchable
              isClearable
              styles={CustomStylesSubSystemOptions}
              placeholder={t("filterSystems")}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option }}
            />
          </Grid>
        </Grid>

        <Paper className={classes.root}>
          <Grid item xs={12}>
            <MaterialTable
              title={t("cpoDeferralsTitle") + blockData?.block.name}
              localization={{
                toolbar: {
                  searchPlaceholder: t("searchPlaceholder"),
                },
                body: {
                  addTooltip: t("addDeferralTooltip"),
                  bulkEditTooltip: t("editDeferralsTooltip"),
                  emptyDataSourceMessage: t("noRecordsMessage"),
                } as any
                //May need to add other translations for the tables here
              }}
              options={{
                actionsCellStyle: {
                  width: "0%",
                },
                actionsColumnIndex: -1,
                draggable: false,
                selection: false,
                padding: "default",
                pageSizeOptions: [],
                showFirstLastPageButtons: false,
                pageSize: 15,
                tableLayout: "auto",
                detailPanelType: "single",
                search: true,
                filtering: false,
                addRowPosition: "first",
              }}
              data={filteredTableData}
              icons={TableIcons}
              editable={{
                onRowAdd: (newData) =>
                  new Promise<void>(async (resolve, reject) => {
                    let manualAddUser =
                      userProfile?.firstName + " " + userProfile?.lastName;

                    if (!newData.date) {
                      alert(t("dateAlert"));
                      return reject(
                        new Error("Validation failed: Date is required."),
                      );
                    }

                    if (!newData.asset) {
                      alert(t("assetAlert"));
                      return reject(
                        new Error("Validation failed: Asset is required."),
                      );
                    }

                    if (cpoDeferralAssets) {
                      const matchedAsset = cpoDeferralAssets.find(
                        (item) => item.assetName === newData.asset,
                      );

                      // Only assign if we successfully found a match
                      if (matchedAsset) {
                        newData.assetID = matchedAsset.assetID;
                      }
                    }

                    if (
                      newData.barrels === undefined ||
                      newData.barrels === null ||
                      isNaN(Number(newData.barrels))
                    ) {
                      alert(t("barrelsAlert"));
                      return reject(
                        new Error(
                          "Validation failed: Barrels must be a number.",
                        ),
                      );
                    }

                    if (
                      newData.scheduled === undefined ||
                      newData.scheduled === null
                    ) {
                      alert(t("plannedUnplannedAlert"));
                      return reject(
                        new Error(
                          "Validation failed: Planned/Unplanned is required.",
                        ),
                      );
                    }

                    if (
                      newData.system === undefined ||
                      newData.system === null ||
                      String(newData.system).trim() === ""
                    ) {
                      alert(t("systemAlert"));
                      return reject(
                        new Error("Validation failed: System is required."),
                      );
                    }

                    const newRowForApi = {
                      ...newData,
                      barrels: Number(newData.barrels),
                      system: String(newData.system),
                      raw: newData.raw,
                      clean: null,
                      editReason: null,
                      manualAddUser: manualAddUser,
                      manuallyAdded: true,
                    };

                    console.log(newData);
                    console.log(newRowForApi);

                    //new row - add 1 at a time

                    //Date - not null
                    //Asset - not null
                    //Raw - null / blank
                    //Barrels - number only
                    //Planned / unplanned - not null
                    //System - not null or undefined
                    //Editing reason - null
                    //manualAddUser - not null - user's name
                    //Manually Added - true

                    try {
                      const url =
                        process.env.REACT_APP_CPO_API_URL +
                        //`http://localhost:8000`+
                        `/api/insert/deferrals`;
                      const token = await auth?.getToken();
                      const response = await fetch(url, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify(newRowForApi),
                      });

                      if (!response.ok) {
                        const errorText = await response.text();
                        console.error("Server error:", errorText);
                        reject(
                          new Error(
                            `Failed to add data: ${response.statusText}`,
                          ),
                        );
                        return;
                      }

                      const result = await response.json();
                      console.log("Row add successful:", result);

                      if (selectedMonth && selectedYear && blockData) {
                        const monthNumber =
                          moment().month(selectedMonth).month() + 1;
                        fetchCpoDeferralData(
                          monthNumber,
                          parseInt(selectedYear, 10),
                          blockData,
                        );
                      }

                      resolve();
                    } catch (error) {
                      console.error("Error adding row:", error);
                      reject(error);
                    }
                  }),
                onBulkUpdate: (changes) =>
                  new Promise<void>(async (resolve, reject) => {
                    const changesArray = Object.values(changes);

                    const newDataArray = changesArray.map(
                      (change) => change.newData,
                    );

                    let latestEditor =
                      userProfile?.firstName + " " + userProfile?.lastName;

                    const updatedDataForApi = newDataArray.map((item) => ({
                      ...item,
                      system: String(item.system),
                      latestEditor: latestEditor,
                      editReason: String(
                        item.editReason === undefined ? 1 : item.editReason,
                      ),
                    }));

                    try {
                      const url =
                        process.env.REACT_APP_CPO_API_URL +
                        `/api/edit/deferrals`;
                      const token = await auth?.getToken();
                      const response = await fetch(url, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify(updatedDataForApi),
                      });

                      if (!response.ok) {
                        const errorText = await response.text();
                        console.error("Server error:", errorText);
                        reject(
                          new Error(
                            `Failed to update data: ${response.statusText}`,
                          ),
                        );
                        return;
                      }

                      const result = await response.json();
                      console.log("Bulk update successful:", result);

                      if (selectedMonth && selectedYear && blockData) {
                        const monthNumber =
                          moment().month(selectedMonth).month() + 1;
                        fetchCpoDeferralData(
                          monthNumber,
                          parseInt(selectedYear, 10),
                          blockData,
                        );
                      }

                      resolve();
                    } catch (error) {
                      console.error("Error sending bulk update:", error);
                      reject(error);
                    }
                  }),
              }}
              columns={[
                {
                  title: t("dateDeferralsTable"),
                  field: "date",
                  editable: "onAdd",
                  type: "date",
                  initialEditValue: "",
                  filtering: false,
                  cellStyle: {
                    width: "10%",
                  },
                  headerStyle: {
                    fontWeight: "bold",
                    width: "10%",
                  },
                  defaultFilter:
                    datePickerChangedBool === false && defaultFilterDate
                      ? defaultFilterDate
                      : null,
                  render: (rowData) => {
                    const date = new Date(rowData.date);
                    if (isNaN(date.getTime())) {
                      return "";
                    }
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");

                    return `${year}-${month}-${day}`;
                  },
                },
                {
                  title: t("assetDeferralsTable"),
                  field: "asset",
                  editable: "onAdd",
                  filtering: false,
                  cellStyle: {
                    width: "10%",
                  },
                  headerStyle: {
                    fontWeight: "bold",
                    width: "10%",
                  },
                  lookup: cpoDeferralAssets?.reduce((acc, asset) => {
                    acc[asset.assetName] = asset.assetName;
                    return acc;
                  }, {}),
                },
                {
                  title: t("rawDeferralsTable"),
                  field: "raw",
                  editable: "onAdd",
                  filtering: false,
                  cellStyle: {
                    width: "25%",
                  },
                  headerStyle: {
                    fontWeight: "bold",
                    width: "25%",
                  },
                  editComponent: (props) => (
                    <TextField
                      multiline
                      maxRows={6}
                      minRows={2}
                      fullWidth
                      value={props.value || ""}
                      onChange={(e) => props.onChange(e.target.value)}
                    />
                  ),
                },
                {
                  title: t("cleanDeferralsTable"),
                  field: "clean",
                  editable: "onUpdate",
                  filtering: false,
                  type: "string",
                  cellStyle: {
                    width: "25%",
                  },
                  headerStyle: {
                    fontWeight: "bold",
                    width: "25%",
                  },
                  editComponent: (props) => (
                    <TextField
                      multiline
                      maxRows={6}
                      minRows={2}
                      fullWidth
                      value={props.value || ""}
                      onChange={(e) => props.onChange(e.target.value)}
                    />
                  ),
                },
                {
                  title: t("barrelsDeferralsTable"),
                  field: "barrels",
                  filtering: false,
                  cellStyle: {
                    width: "10%",
                  },
                  headerStyle: {
                    fontWeight: "bold",
                    width: "10%",
                  },
                  render: (rowData) => {
                    const barrelsValue = rowData.barrels;
                    if (
                      typeof barrelsValue === "number" &&
                      !isNaN(barrelsValue)
                    ) {
                      return barrelsValue.toFixed(3);
                    }
                    if (
                      typeof barrelsValue === "string" &&
                      !isNaN(parseFloat(barrelsValue))
                    ) {
                      return parseFloat(barrelsValue).toFixed(3);
                    }
                    return barrelsValue ?? "";
                  },
                },
                {
                  title: t("plannedUnplannedDeferralsTable"),
                  field: "scheduled",
                  filtering: false,
                  cellStyle: {
                    width: "10%",
                  },
                  headerStyle: {
                    fontWeight: "bold",
                    width: "10%",
                  },
                  lookup: plannedUnplannedLookup,
                },
                {
                  title: t("systemDeferralsTable"),
                  field: "system",
                  filtering: false,
                  cellStyle: {
                    width: "10%",
                  },
                  headerStyle: {
                    fontWeight: "bold",
                    width: "10%",
                  },
                  render: (rowData) => {
                    const matchedSystem = cpoDeferralSystems?.find(
                      (system) => rowData.system === system.systemNumber,
                    );
                    if (matchedSystem) {
                      return matchedSystem.systemName;
                    } else {
                      return "N/A";
                    }
                  },
                  lookup: cpoDeferralSystems?.reduce((acc, system) => {
                    acc[system.systemNumber] = system.systemName;
                    return acc;
                  }, {}),
                },
                {
                  title: t("editingReasonDeferralsTable"),
                  field: "editReason",
                  filtering: false,
                  editable: (columnDef, rowData) => {
                    // enable editing for bulkUpdate but disable for addRow
                    const data = rowData as any;
                    return (
                      data && data.tableData && data.tableData.id !== undefined
                    );
                  },
                  cellStyle: {
                    width: "10%",
                  },
                  headerStyle: {
                    fontWeight: "bold",
                    width: "10%",
                  },
                  render: (rowData) => {
                    const matchedEditReason = cpoEditReasons?.find(
                      (editReason) =>
                        rowData.editReason === editReason.reasonNumber,
                    );
                    if (matchedEditReason) {
                      return matchedEditReason.reason;
                    } else {
                      return "N/A";
                    }
                  },
                  lookup: cpoEditReasons?.reduce((acc, editReason) => {
                    acc[editReason.reasonNumber] = editReason.reason;
                    return acc;
                  }, {}),
                },
                {
                  title: t("manuallyAddedDeferralsTable"),
                  field: "manuallyAdded",
                  filtering: false,
                  editable: "never",
                  cellStyle: {
                    width: "10%",
                  },
                  headerStyle: {
                    fontWeight: "bold",
                    width: "10%",
                  },
                  render: (rowData) => {
                    if (rowData.manuallyAdded === true) {
                      let manualAddDisplay =
                        "Yes - by " + rowData.manualAddUser;
                      return manualAddDisplay;
                    } else {
                      return "No";
                    }
                  },
                },
              ]}
            ></MaterialTable>
            </Grid>
          </Paper>
        </>
  );
};
